import axios from "axios";
import {SERVER_URL} from "config";
import {authHeader} from "_helpers";

function getCompanyRetainCampaigns() {
    const endpoint = `${SERVER_URL}/api/v2/my-organization/proactive/email/metrics/campaigns`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function getCompanyRetainMetrics(params) {
    const endpoint = `${SERVER_URL}/api/v2/my-organization/proactive/email/metrics/summary`;
    return axios.get(endpoint, {
        params: params,
        headers: authHeader()
    });
}

function getOrganizationRetainCampaigns(organizationId, params) {
    const endpoint = `${SERVER_URL}/api/v2/organizations/${organizationId}/proactive/email/metrics/campaigns`;
    return axios.get(endpoint, {
        params,
        headers: authHeader()
    });
}

function getOrganizationRetainMetrics(organizationId, params) {
    const endpoint = `${SERVER_URL}/api/v2/organizations/${organizationId}/proactive/email/metrics/summary`;
    return axios.get(endpoint, {
        params,
        headers: authHeader()
    });
}

export const retainService = {
    getCompanyRetainCampaigns,
    getCompanyRetainMetrics,
    getOrganizationRetainCampaigns,
    getOrganizationRetainMetrics
}